import Vue from 'vue'

import commonsApi from '@/api/commons'

import LumbreApp from '@/views/LumbreApp'

class MetaBreadcrumb {
  constructor (name, to) {
    this.name = name
    this.to = to
  }
}

export const generateRoutes = async () => {
  try {
    const { data } = await commonsApi.axiosGetWrapper('/frontendroutes/myroutes')
    const myRotues = data

    const requiredViews = require.context(
      '@/views', // Path donde obtener las vistas
      true, // Busco en subcarpetas
      /[\w-]+\.vue$/
    )

    let regExp = null
    if (process?.env?.VUE_APP_PROYECT_VIEWS_FOLDER) {
      regExp = new RegExp(`^(\\.\\/${process.env.VUE_APP_PROYECT_VIEWS_FOLDER}\\/){1}\\S+.vue$|^(\\.\\/Lm[a-zA-Z0-9]+\\.vue$)|^(\\.\\/lumbresign\\/[a-zA-Z0-9\\/]+\\.vue$)`, 'i')
    } else {
      regExp = new RegExp(`^(\\.\\/Lm[a-zA-Z0-9]+\\.vue)|^(\\.\\/lumbresign\\/[a-zA-Z0-9\\/]+\\.vue$)`, 'i')
    }
    /*
      Si tengo definida una carpeta del proyecto busca y solo importa los archivos con "./[carpeta]/[...]"
      Si no tengo definida una carpeta del proyecto busca y solo importa los archivos con "./Lm[...].vue"
      Tambien incluyo los archivos de la carpeta "lumbresign" siempre
    */

    requiredViews.keys().forEach((fileName) => {
      if (regExp && fileName.match(regExp)) {
        const componentConfig = requiredViews(fileName)
        const componentName = fileName
          .replace(/^\.\//, '')
          .replace(/\.\w+$/, '')
          .split('-')
          .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
          .join('')
          // Para las subcarpetas - Carpeta-LmComponente
          .split('/')
          .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
          .join('-')

        const useComponent = myRotues.some(route => {
          if (componentName.includes('-')) {
            // Si el nombre del componente contiene "-" asumo que es una subcarpeta y comparo
            // el nombre vueComponent (que debe comenzar con /) con la primera carpeta
            // TODO. Puede mejorarse
            // Ej. /lumbresign
            if (typeof route?.vueComponent === 'string') {
              return route?.vueComponent?.toLowerCase() === `/${componentName.split('-')[0].toLowerCase()}`
            }
          } else {
            if (typeof route?.vueComponent === 'string') {
              return route?.vueComponent?.toLowerCase() === componentName.toLowerCase()
            } else if (Array.isArray(route?.vueComponent)) {
              return route?.vueComponent?.some(component => component.toLowerCase() === componentName.toLowerCase())
            }
          }
        })
        // Solo inserto los componentes que el usuario requiere a la instancia de Vue
        if (useComponent) {
          Vue.component(componentName, componentConfig.default || componentConfig)
        }
      }
    })

    const routes = []

    if (Array.isArray(myRotues)) {
      myRotues.forEach(newRoute => {
        newRoute['component'] = LumbreApp

        if (newRoute?.meta?.breadcrumb) {
          newRoute.meta.breadcrumb = new MetaBreadcrumb(newRoute.meta.breadcrumb)
        }

        if (Array.isArray(newRoute?.children)) {
          newRoute.children = newRoute.children.map(child => {
            child.component = Vue.options.components[child.component]
            return child
          })
        }
        routes.push(newRoute)
      })
    }
    return routes
  } catch (error) {
    throw new Error('No se pudieron obtener las rutas para Lumbre.')
  }
}
